import { useMemo } from 'react';

import {
  platformAPINavItems,
  primaryNavItems,
  productAPINavItems,
  standalonePlatformAPINavItems,
} from ':cloud/config/navigation';
import { useBOAT } from ':cloud/hooks/featureFlags/useBOAT';
import { useIsOnParticipateAllowlist } from ':cloud/hooks/featureFlags/useIsOnParticipateAllowlist';
import { useIsOnStakingAllowlist } from ':cloud/hooks/featureFlags/useIsOnStakingAllowlist';
import { useIsWalletHistoryEnabled } from ':cloud/hooks/featureFlags/useIsWalletHistoryEnabled';

import { useIsBaseAppchainsEnabled } from './featureFlags/useIsBaseAppchainsEnabled';
import { useIsBaseL3Enabled } from './featureFlags/useIsBaseL3Enabled';

export function useGetNavMenuItems() {
  const isOnStakingApiAllowlist = useIsOnStakingAllowlist();
  const isOnParticipateAllowlist = useIsOnParticipateAllowlist();
  const isOnBOATAllowlist = useBOAT();
  const isWalletHistoryEnabled = useIsWalletHistoryEnabled();
  const isBaseL3Enabled = useIsBaseL3Enabled();
  const isBaseAppchainsEnabled = useIsBaseAppchainsEnabled();

  return useMemo(() => {
    const displayedPrimaryNavItems = primaryNavItems;

    const displayedStandalonePlatformAPINavItems = standalonePlatformAPINavItems.filter((item) => {
      if (
        (item.id === 'participate' && !isOnParticipateAllowlist) ||
        (item.id === 'staking' && !isOnStakingApiAllowlist)
      ) {
        return false;
      }
      return true;
    });

    const displayedPlatformAPINavItems = platformAPINavItems.filter((item) => {
      // if newer experiment is enabled, hide old flow
      // prev experiment was never fully enabled
      if (item.id === 'base-l3' && isBaseAppchainsEnabled) {
        return false;
      }
      if (
        (item.id === 'onchainkit' && !isOnBOATAllowlist) ||
        (item.id === 'wallet_history' && !isWalletHistoryEnabled) ||
        (item.id === 'base-appchains' && !isBaseAppchainsEnabled) ||
        (item.id === 'base-l3' && !isBaseL3Enabled)
      ) {
        return false;
      }
      return true;
    });

    // Leaving this here as a placeholder in case we need to filter items in the future
    const displayedProductAPINavItems = productAPINavItems;

    const allDisplayedNavItems = [
      ...displayedPrimaryNavItems,
      ...displayedPlatformAPINavItems,
      ...displayedStandalonePlatformAPINavItems,
      ...displayedProductAPINavItems,
    ];

    return {
      allDisplayedNavItems,
      displayedPrimaryNavItems,
      displayedPlatformAPINavItems,
      displayedStandalonePlatformAPINavItems,
      displayedProductAPINavItems,
    };
  }, [
    isOnParticipateAllowlist,
    isOnStakingApiAllowlist,
    isBaseAppchainsEnabled,
    isOnBOATAllowlist,
    isWalletHistoryEnabled,
    isBaseL3Enabled,
  ]);
}
